




























































































































import enrollmentsListeners, {
  EnrollmentOrdersListeners
} from "@/getinfo-api/enrollments-listeners";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { Course as ICourse } from "@/api/models/course";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { EnrollmentOrderEdit as IEnrollmentOrderEdit } from "@/api/models/enrollment-order-edit";
import { Employee as IEmployee } from "@/api/models/employee";
import api from "@/getinfo-api";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import ListenersTable from "@/components/tables/ListenerTable.vue";
import CField from "@/components/form/CField.vue";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { nextSequence } from "@/utils/generate-helper";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import enrollmentList, {
  EnrollmentOrdersListParam
} from "@/getinfo-api/enrollment-orders";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import { debounce } from "lodash";
import { EnrollmentOrderShort as IEnrollmentOrder } from "@/api/models/enrollment-order-short";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import EnrollmentOrderListItem from "@/components/enrollment/EnrollmentOrderListItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: {
    CustomButton,
    EnrollmentOrderListItem,
    CBlock,
    CSingleSelect,
    DocumentNumberInput,
    CField,
    SelectEntity,
    CustomDatepicker,
    ListenersTable
  }
})
export default class EnrollmentOrderForm extends Vue {
  @Prop() propCourseId!: string;
  @Prop() propEducationStartedAt!: Date;
  @Prop() propFinishedAt!: Date;
  @Prop({ default: false }) isNewWindowOnSave?: boolean;
  course!: any;
  number: string = "";
  courses: Array<string> = [];
  courseId!: string;
  duplicateOrders: IEnrollmentOrder[] = [];
  allListeners: Array<ICourseListener> = [];
  listeners: Array<ICourseListener> = [];
  listenersCount: number = 0;
  showSpinner: boolean = false;
  selectedListeners: Array<string> = [];
  signedAt!: Date;
  formedAt: Date = new Date();
  educationStartedAt!: Date;
  educationFinishedAt!: Date;
  ownerId!: string;
  employees!: Array<IEmployee> | undefined;
  coursesList: CoursesListClass = new CoursesListClass(
    { mode: "v2" },
    this.propCourseId ? this.propCourseId : this.courseId
  );

  data() {
    return {
      educationStartedAt: undefined,
      educationFinishedAt: undefined,
      courseId: undefined,
      signedAt: undefined,
      ownerId: undefined,
      course: undefined,
      employees: undefined
    };
  }

  changeCourse(item: any) {
    this.course = item;
    this.getEmployeeIdCourseOwner(item.owner.id);
  }

  countStartFromFinished() {
    this.educationStartedAt = this.$store.getters[
      "companyUtils/GET_START_FROM_FINISH"
    ](this.educationFinishedAt, this.course.hours);
  }

  countFinishFromStart() {
    this.educationFinishedAt = this.$store.getters[
      "companyUtils/GET_FINISH_FROM_START"
    ](this.educationStartedAt, this.course.hours);
  }

  @Watch("educationStartedAt")
  checkEducationStartedAt() {
    this.selectedListeners = [];
    this.getEnrollmentListeners();
  }

  getListeners(list: Array<ICourseListener>) {
    this.selectedListeners = list.map(el => el.id);
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany?.id
      ? this.$store.getters.selectedCompany.id
      : localStorage.getItem("selectedCompany");
  }

  getEmployeeIdCourseOwner(userId: string) {
    let params: EmployeeListParams = {
      id: this.selectedCompany,
      userIds: [userId]
    };
    employee(params).then((res: { data: IEmployeesList2 }) => {
      this.ownerId = res.data.employees[0].id;
    });
  }

  getEnrollmentListeners() {
    this.allListeners = [];
    this.showSpinner = true;
    let params: EnrollmentOrdersListeners = {
      courseId: this.courseId,
      hasProtocol: false,
      limit: 1000
    };
    if (this.educationStartedAt) {
      params.createdAtMin = new Date(this.educationStartedAt);
      let educationStartedAtMax = new Date(this.educationStartedAt);
      educationStartedAtMax.setHours(23);
      educationStartedAtMax.setMinutes(59);
      params.createdAtMax = educationStartedAtMax;
    }
    enrollmentsListeners(params)
      .then((res: { data: any }) => {
        this.listenersCount = res.data.count;
        this.allListeners = res.data.listeners;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => (this.showSpinner = false));
  }

  @Watch("courseId")
  updateListeners() {
    this.selectedListeners = [];
    this.listeners = [];
    this.getEnrollmentListeners();
  }

  @Watch("selectedCompany")
  updateEmployees() {
    this.employees = undefined;
  }

  @Watch("number")
  @Watch("courseId")
  checkNumber = debounce(function() {
    //@ts-ignore
    let _this = this;
    if (_this.courseId && _this.number) {
      let params: EnrollmentOrdersListParam = {
        number: _this.number.length > 0 ? _this.number : undefined,
        courseIds: [_this.courseId],
        limit: 30
      };

      enrollmentList(params).then(res => {
        _this.duplicateOrders = res.data.items;
      });
    }
  }, 400);

  async useThisOrder(item: IEnrollmentOrder) {
    this.showSpinner = true;
    let { data } = await api.EnrollmentOrderApi.get(item.id);
    if (data) {
      const edit: IEnrollmentOrderEdit = {
        ownerId: data.ownerId,
        formedAt: data.formedAt,
        number: data.number,
        signedAt: data.signedAt,
        educationFinishedAt: data.educationFinishedAt,
        educationStartedAt: data.educationStartedAt,
        listeners: [
          ...this.selectedListeners,
          ...data.listeners.map(el => el.id)
        ],
        courseId: data.courseId,
        fileIds: data.files?.map((el: any) => el.id)
      };
      await api.EnrollmentOrderApi.edit(item.id, edit)
        .then(async res => {
          if (this.isNewWindowOnSave) {
            let routeData = this.$router.resolve({
              name: "enrollmentOrder",
              params: { enrollmentId: res.data.id }
            });
            await window.open(routeData.href, "_blank");
            this.$emit("saveEnrollment", res.data);
          } else {
            await this.$router.push({
              name: "enrollmentOrder",
              params: { enrollmentId: res.data.id }
            });
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
      this.showSpinner = false;
    }
  }

  get root() {
    return isRoot();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get userId() {
    return getCurrentUserId();
  }

  async saveEnrollment() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    if (this.$store.getters.GET_FORM_IS_INVALID) {
      return;
    }
    let params: IEnrollmentOrderEdit = {
      number: this.number,
      signedAt: this.signedAt,
      formedAt: this.formedAt,
      ownerId: this.ownerId,
      educationStartedAt: this.educationStartedAt,
      educationFinishedAt: this.educationFinishedAt,
      courseId: this.courseId,
      listeners: this.selectedListeners,
      fileIds: []
    };

    api.EnrollmentOrderApi.create(params)
      .then(async res => {
        await nextSequence();
        if (this.isNewWindowOnSave) {
          let routeData = this.$router.resolve({
            name: "enrollmentOrder",
            params: { enrollmentId: res.data.id }
          });
          await window.open(routeData.href, "_blank");
          this.$emit("saveEnrollment", res.data);
        } else {
          await this.$router.push({
            name: "enrollmentOrder",
            params: { enrollmentId: res.data.id }
          });
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.educationStartedAt = new Date();
    this.educationStartedAt.setHours(0, 0, 0, 0);
    if (this.propCourseId) {
      this.courseId = this.propCourseId;
    }
    if (this.propEducationStartedAt) {
      this.educationStartedAt = new Date(this.propEducationStartedAt);
      this.educationStartedAt.setHours(0, 0, 0, 0);
    }
    if (this.propFinishedAt) {
      this.educationFinishedAt = new Date(this.propFinishedAt);
    }
  }
}
